import { Routes } from "@trueskin-web/translations"

export const getHomepageUrl = (isUserLogged) =>
  isUserLogged ? Routes.App.url + "/" : process.env.GATSBY_WEBSITE_URL
